/**
 * Determines whether the activity completed with time to spare.
 */
export function didActivityHaveExtraCapacity(activityBandwidthVerifier) {
    var currentTime = performance.now();
    var elapsedDuration = currentTime - activityBandwidthVerifier.startTime;
    var remainingDuration = activityBandwidthVerifier.expirationTime - currentTime;
    return remainingDuration > elapsedDuration;
}
//# sourceMappingURL=didActivityHaveExtraCapacity.js.map